import { useReducer } from 'react';

const initialState = {
  dxFilterValue: '',
  hccFilterValue: '',
  isVisible: false
};

const ACTION_TYPES = {
  SHOW_LOOKBACK: 'SHOW_LOOKBACK',
  HIDE_LOOKBACK: 'HIDE_LOOKBACK',
  SET_LOOKBACK_FILTER_VALUE: 'SET_LOOKBACK_FILTER_VALUE'
};

const ACTIONS = {
  showLookback: () => ({
    type: ACTION_TYPES.SHOW_LOOKBACK
  }),
  hideLookback: () => ({
    type: ACTION_TYPES.HIDE_LOOKBACK
  }),
  setLookbackFilterValue: (name, value) => ({
    type: ACTION_TYPES.SET_LOOKBACK_FILTER_VALUE,
    payload: {
      name,
      value
    }
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SHOW_LOOKBACK: {
      return { ...state, isVisible: true };
    }

    case ACTION_TYPES.HIDE_LOOKBACK: {
      return {
        ...state,
        isVisible: false,
        dxFilterValue: '',
        hccFilterValue: ''
      };
    }

    case ACTION_TYPES.SET_LOOKBACK_FILTER_VALUE: {
      const { payload } = action;

      return {
        ...state,
        [
          payload.name === 'dx' ? 'dxFilterValue' : 'hccFilterValue'
        ]: payload.value
      };
    }

    default: {
      throw Error('useLookback reducer should never hit default');
    }
  }
};

const useLookback = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const show = () => dispatch(ACTIONS.showLookback());
  const hide = () => dispatch(ACTIONS.hideLookback());
  const setFilterValue = (name, value) =>
    dispatch(ACTIONS.setLookbackFilterValue(name, value));

  const boundActions = {
    show,
    hide,
    setFilterValue
  };

  return [state, boundActions];
};

export default useLookback;
